var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkgreen03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0f3f2e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic_icon_of_descent_bars",
    "data-name": "Graphic icon of descent bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.05,
    y: 53.62,
    width: 15.41,
    height: 21.88,
    rx: 0.93,
    ry: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.3,
    y: 40.7,
    width: 15.41,
    height: 34.8,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.54,
    y: 24.5,
    width: 15.41,
    height: 51,
    rx: 1.26,
    ry: 1.26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkgreen03);
export default __webpack_public_path__ + "static/media/darkgreen03.274a939c58f0366cc25938908745a934.svg";
export { ForwardRef as ReactComponent };